@if (pendingAlarms(); as alarmsData) {
  <div
    class="container"
    tooltip="Revisar alertas"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    tooltipPosition="left"
    (click)="changeFlag()"
    role="button"
    [attr.aria-label]="'Botón de alertas' + (alarmsData.length > 0 ? ', ' + alarmsData.length + ' alertas pendientes' : '')"
    [attr.aria-expanded]="isOpen"
    [attr.aria-haspopup]="'dialog'"
    tabindex="0"
    (keydown.enter)="changeFlag()"
    (keydown.space)="changeFlag()"
  >
    @if (bellStatus() !== 'loading') {
      <i class="fa-solid fa-bell" [attr.aria-hidden]="true"></i>
      @if (alarmsData.length > 0) {
        <div class="indicator">
          <div
            class="noti_count"
            role="status"
            [attr.aria-label]="alarmsData.length + ' alertas pendientes'"
          >
            <i class="fas fa-exclamation" [attr.aria-hidden]="true"></i>
          </div>
        </div>
      }
    } @else {
      <i
        class="fa-solid fa-spinner fa-spin"
        role="status"
        [attr.aria-label]="'Cargando alertas'"
        [attr.aria-live]="'polite'"
      ></i>
    }
  </div>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'backdrop'"
    (overlayOutsideClick)="changeFlag()"
  >
    <div
      class="alarms-container"
      role="dialog"
      [attr.aria-label]="'Panel de alertas pendientes'"
      [attr.aria-modal]="true"
    >
      <h4
        class="header-underline"
        role="heading"
        [attr.aria-level]="4"
      >
        Alertas <span>pendientes</span>
      </h4>
      <hr [attr.aria-hidden]="true" role="presentation" />
      <div>
        <cdk-virtual-scroll-viewport
          itemSize="50"
          class="vs-viewport"
          minBufferPx="200"
          maxBufferPx="400"
          (scrolledIndexChange)="onScroll(viewport)"
          #viewport
          [attr.aria-label]="'Lista de alertas pendientes'"
          role="region"
        >
          <div
            class="alarms-list"
            role="list"
          >
            <ng-container *cdkVirtualFor="let item of alarmsList()">
              @if (!item.was_read) {
                <div
                  class="vs-item"
                  (click)="select(item)"
                  role="listitem"
                  [attr.aria-label]="'Alerta: ' + item.alarm_title + ', fecha: ' + (item.alarm_datetime | date : 'dd-MM-yyyy hh:mm a')"
                  tabindex="0"
                  (keydown.enter)="select(item)"
                  (keydown.space)="select(item)"
                >
                  <p>{{ item.alarm_title }}</p>
                  <p class="date">
                    {{ item.alarm_datetime | date : "dd-MM-yyyy hh:mm a" }}
                  </p>
                </div>
              }
            </ng-container>
            @if (!hasMoreData()) {
              <div
                class="no-more-data"
                role="status"
                [attr.aria-live]="'polite'"
              >
                <span>No hay más alertas disponibles para mostrar.</span>
              </div>
            }
          </div>
        </cdk-virtual-scroll-viewport>

        @if (status === 'loading') {
          <i
            class="fa-solid fa-spinner fa-spin"
            role="status"
            [attr.aria-label]="'Cargando alertas'"
            [attr.aria-live]="'polite'"
          ></i>
        }
      </div>
    </div>
  </ng-template>
}
